import React from 'react';
import { StyledManageContactsRemovePhone, StyledManageContactsRemovePhoneCTA, StyledManageContactsRemovePhoneCustomCTA, StyledManageContactsRemovePhoneDescription } from './styled';
import { Bin, Breakpoints, CTA, Edit, TextAppearance, TextColor, TextCustom, TextLineHeight, TextSize, TextType, TextWeight, ThemeProvider } from '@vw-marketing/us-components';
import { applyTextTransformations } from '../../../../shared/utils/applyTextTransformations';
import { ManageContactsMutation } from '../../../../shared/typings/main';
import { onVWBasicButtonClickWithProcessEvent } from '../../../../shared/tagging/tagging-helpers';

interface ManageContactsRemovePhoneViewProps {
  trackingManager: any;
  onRemove: (mutation: ManageContactsMutation) => Promise<void>;
  onSuccess: () => void;
  onError: () => void;
  handleAddEditPhone: (flow: "add" | "edit", initialPhoneNumber?: string) => void;
  translationHandler: (key: string) => string;
  phoneToRemove: string;
}

export const ManageContactsRemovePhoneView: React.FC<ManageContactsRemovePhoneViewProps> = ({
  trackingManager,
  onRemove,
  onSuccess,
  onError,
  handleAddEditPhone,
  translationHandler,
  phoneToRemove
}) => {
  const removePhone = async () => {
    try {
      onVWBasicButtonClickWithProcessEvent(trackingManager, {
        Name: 'Account Settings',
        StepName: `Personal Information and Security - Manage Contacts - Remove Mobile Number`,
        StepNumber: '4.5',
      }, {
        name: 'Remove mobile number',
      });

      await onRemove({ isEdit: false, isRemove: true, initialValue: phoneToRemove.replace(/\D/g, ''), value: phoneToRemove.replace(/\D/g, '') });
      onSuccess();
    } catch (error) {
      console.error('There was an error removing your phone number', error);
      onError();
    }
  };

  return (
    <ThemeProvider theme="main">
      <StyledManageContactsRemovePhone>
        <StyledManageContactsRemovePhoneDescription>
          <TextCustom
            appearance={TextAppearance.copy200}
            style={{
              [Breakpoints.default]: {
                color: TextColor.primary,
                fontSize: TextSize.TextSize16,
                fontType: TextType.Copy,
                lineHeight: TextLineHeight.TextLineHeight24,
              }
            }}
          >
            <TextCustom
              appearance={TextAppearance.copy200}
              style={{
                [Breakpoints.default]: {
                  color: TextColor.primary,
                  fontWeight: TextWeight.bold,
                  fontSize: TextSize.TextSize16,
                  fontType: TextType.Copy,
                  lineHeight: TextLineHeight.TextLineHeight24,
                }
              }}
            >
              "{applyTextTransformations(phoneToRemove, [phoneToRemove])}"
            </TextCustom>
            {translationHandler("accountSettings.manage.contacts.interaction.layer.remove.description")}
          </TextCustom>
        </StyledManageContactsRemovePhoneDescription>
        <StyledManageContactsRemovePhoneCTA>
          <StyledManageContactsRemovePhoneCustomCTA
            tag="button"
            icon={<Bin variant="small" />}
            size="large"
            stretchContent={true}
            onClick={async () => await removePhone()}
          >
            {translationHandler("accountSettings.manage.contacts.interaction.layer.sms.alerts.remove.phone.cta.remove")}
          </StyledManageContactsRemovePhoneCustomCTA>
          <CTA
            tag="button"
            emphasis='secondary'
            icon={<Edit variant="small" />}
            size="large"
            stretchContent={true}
            onClick={() => handleAddEditPhone('edit', phoneToRemove)}
          >
            {translationHandler("accountSettings.manage.contacts.interaction.layer.sms.alerts.remove.phone.cta.edit")}
          </CTA>
        </StyledManageContactsRemovePhoneCTA>
      </StyledManageContactsRemovePhone>
    </ThemeProvider>
  )
};
